export const P0003601CapteurTemperatureEnum = [
  {
    ref: 0,
    label: 'P0003601.installation.prevention.capteurTemperature.0',
    visible: false,
  },
  {
    ref: 1,
    label: 'P0003601.installation.prevention.capteurTemperature.1',
    visible: true,
  },
  {
    ref: 2,
    label: 'P0003601.installation.prevention.capteurTemperature.2',
    visible: true,
  },
];

export const P0003601CapteurTemperatureEnumWithNone = [
  {
    ref: 0,
    label: 'P0003601.installation.prevention.capteurTemperature.0',
    visible: true,
  },
  {
    ref: 1,
    label: 'P0003601.installation.prevention.capteurTemperature.1',
    visible: true,
  },
  {
    ref: 2,
    label: 'P0003601.installation.prevention.capteurTemperature.2',
    visible: true,
  },
];
